import { ClassNameMap } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useLegacyLayoutClasses = makeStyles<{ drawerWidth?: number; classes?: ClassNameMap<'root' | 'main'> }>({ name: 'LayoutClasses' })((theme, { drawerWidth = 240 }) => ({
  root: {
    display: 'flex',
    whiteSpace: 'pre-wrap',
    height: '100%',
    '& *': {
      fontFamily: theme.typography.fontFamily,
    },
  },
  main: {},
  appBar: {
    background: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: `0px -1px 0 0 ${theme.palette.divider} inset`,
    zIndex: theme.zIndex.drawer + 100,
  },
  appBarShift: {
    width: '100%',
    zIndex: theme.zIndex.drawer - 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  drawer: {
    flexShrink: 0,
    width: '0px',
    zIndex: theme.zIndex.appBar,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerOpened: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    maxWidth: '100%',
    boxSizing: 'border-box',
    flexGrow: 1,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flexGrow: 1,
  },
  toolBar: {
    display: 'flex',
    alignItems: 'center',
  },
}));
